import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'react-perfect-scrollbar/dist/css/styles.css';
import 'nprogress/nprogress.css';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { enableES5 } from 'immer';
import * as serviceWorker from 'src/serviceWorker';
import store from 'src/store';
import { SettingsProvider } from 'src/contexts/SettingsContext';
import App from 'src/App';
import { redirectIfRetiredImmediately } from 'src/v2Sunset';

enableES5();

// Retired auth pages leave for v2 before React mounts, so they never paint v1 chrome.
const leavingForV2 = redirectIfRetiredImmediately();

if (!leavingForV2) {
  ReactDOM.render(
    <>
      <Provider store={store}>
        <SettingsProvider>
          <App />
        </SettingsProvider>
      </Provider>
    </>,
    document.getElementById('root')
  );

  serviceWorker.unregister();
}

// Skipped when we are already on our way to v2 — two navigations would race.
if (!leavingForV2 && window.location.hostname === 'tracking.oagenius.com') {
  window.location.hostname = 'app.tracktaco.com';
}
